// extracted by mini-css-extract-plugin
export default {"center":"center__tGSbB4ttEYl2"};